<template>
  <b-form-checkbox size="sm" :checked="isDoneAndClosed" :disabled="true"></b-form-checkbox>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'

export default {
  name: 'InitiativeIcon',
  props: ['isDoneAndClosed'],
  components: {
    BFormCheckbox
  }
}
</script>

<style lang="scss" scoped></style>
